import { AxiosError } from "axios";

const INVALID_BASKET_STATUS = "invalid basket status";

const collectErrorText = (err: unknown): string => {
  const parts: string[] = [];

  if (typeof err === "string") {
    parts.push(err);
  }

  if (err instanceof Error) {
    parts.push(err.message);
  }

  if (err && typeof err === "object" && "response" in err) {
    const response = (err as AxiosError).response;

    // Compax often returns the full phrase as the body, e.g.
    // `400 Bad Request: ""invalid basket status""` — coerce with `${}` like
    // other frontend-api error checks in this repo.
    if (response?.data !== undefined) {
      parts.push(`${response.data}`);
    }
  }

  try {
    parts.push(JSON.stringify(err));
  } catch {
    // ignore circular / non-serializable values
  }

  return parts.join(" ");
};

/**
 * Compax returns 400 with "invalid basket status" when a basket can no longer
 * accept options (e.g. already checked out / otherwise closed). The only
 * recovery is to invalidate it and start a new basket.
 */
export const isInvalidBasketStatusError = (err: unknown): boolean =>
  collectErrorText(err).toLowerCase().includes(INVALID_BASKET_STATUS);
